import { Layer } from "./layer";
/**
 * 栅格图层
 */
export class RasterLayer extends Layer {
    constructor() {
        super(...arguments);
        /**
         * 图层可交互设置
         */
        this._interactive = false;
    }
    get raster() {
        return this._raster;
    }
    set raster(value) {
        this._raster = value;
    }
    set crs(value) {
        this._crs = value;
        if (this._raster) {
            this._raster.crs = value;
        }
    }
    /**
     * 数据变换
     * @param {ScreenXY} origin - 窗口坐标原点
     * @param {number} zoom - 当前缩放级别
     */
    transform(origin, zoom) {
        if (this._raster) {
            this._origin = origin;
            this._zoom = zoom;
            this._raster.transform(origin, zoom);
        }
    }
    /**
     * 绘制图层
     * @remarks
     * 遍历图形集合进行绘制
     * @param {CanvasRenderingContext2D} ctx - 绘图上下文
     * @param {Projection} projection - 坐标投影转换
     * @param {Bound} extent - 当前可视范围
     * @param {number} zoom - 当前缩放级别
     */
    draw(ctx, zoom, redrawBounds) {
        if (!this.visible || this.minZoom > zoom || this.maxZoom < zoom)
            return;
        if (!this.raster.screenBounds || this.raster.screenBounds.intersects(redrawBounds)) {
            this.raster && this.raster.draw(ctx);
        }
    }
}
